import React, { useState, useRef } from "react";
import {
  List,
  ListItem,
  ListItemText,
  Drawer,
  Box,
  ButtonBase,
  ListItemIcon,
} from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DescriptionIcon from "@mui/icons-material/Description";
import MainLayout from "../Common/MainLayout";
import { useNavigate } from "react-router-dom";
import UserManagement from "./UserManagement";
import DashboardManagement from "./DashboardManagement";
import DocumentManagement from "./DocumentManagement";

const AdminPage = () => {
  const [selectedSection, setSelectedSection] = useState("users");
  const navigate = useNavigate();
  const sectionContainerRef = useRef(null);

  const handleSectionSelect = (section) => {
    setSelectedSection(section);
    navigate('', { replace: true });
    if (sectionContainerRef.current) {
      sectionContainerRef.current.scrollTop = 0;
    }
  };

  const renderSectionContent = () => {
    switch (selectedSection) {
      case "users":
        return <UserManagement />;
      case "dashboards":
        return <DashboardManagement />;
      case "documents":
        return <DocumentManagement />;
      default:
        return null;
    }
  };

  return (
    <MainLayout>
      <Drawer
        variant="permanent"
        sx={{
          width: 240,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: 240,
            boxSizing: "border-box",
            position: "relative",
          },
        }}
      >
        <Box sx={{ overflow: "hidden", m: 2 }}>
          <List>
            <ButtonBase
              onClick={() => handleSectionSelect("users")}
              sx={{
                width: "100%",
                textAlign: "left",
                justifyContent: "flex-start",
                bgcolor: selectedSection === "users" ? "secondary.main" : "transparent",
                "&:hover": {
                  bgcolor: "secondary.light",
                  transform: "scale(1.02)",
                },
                transition: "transform .2s, background-color .2s",
                cursor: "pointer",
              }}
            >
              <ListItem sx={{ padding: "4px 8px", width: "100%", minHeight: 32 }}>
                <ListItemIcon sx={{ minWidth: 30 }}>
                  <PeopleIcon sx={{ fontSize: "1rem" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Users"
                  primaryTypographyProps={{
                    fontWeight: selectedSection === "users" ? "bold" : "fontWeightMedium",
                    fontSize: "0.875rem",
                  }}
                />
              </ListItem>
            </ButtonBase>
            <ButtonBase
              onClick={() => handleSectionSelect("dashboards")}
              sx={{
                width: "100%",
                textAlign: "left",
                justifyContent: "flex-start",
                bgcolor: selectedSection === "dashboards" ? "secondary.main" : "transparent",
                "&:hover": {
                  bgcolor: "secondary.light",
                  transform: "scale(1.02)",
                },
                transition: "transform .2s, background-color .2s",
                cursor: "pointer",
              }}
            >
              <ListItem sx={{ padding: "4px 8px", width: "100%", minHeight: 32 }}>
                <ListItemIcon sx={{ minWidth: 30 }}>
                  <DashboardIcon sx={{ fontSize: "1rem" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Dashboards"
                  primaryTypographyProps={{
                    fontWeight: selectedSection === "dashboards" ? "bold" : "fontWeightMedium",
                    fontSize: "0.875rem",
                  }}
                />
              </ListItem>
            </ButtonBase>
            <ButtonBase
              onClick={() => handleSectionSelect("documents")}
              sx={{
                width: "100%",
                textAlign: "left",
                justifyContent: "flex-start",
                bgcolor: selectedSection === "documents" ? "secondary.main" : "transparent",
                "&:hover": {
                  bgcolor: "secondary.light",
                  transform: "scale(1.02)",
                },
                transition: "transform .2s, background-color .2s",
                cursor: "pointer",
              }}
            >
              <ListItem sx={{ padding: "4px 8px", width: "100%", minHeight: 32 }}>
                <ListItemIcon sx={{ minWidth: 30 }}>
                  <DescriptionIcon sx={{ fontSize: "1rem" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Documents"
                  primaryTypographyProps={{
                    fontWeight: selectedSection === "documents" ? "bold" : "fontWeightMedium",
                    fontSize: "0.875rem",
                  }}
                />
              </ListItem>
            </ButtonBase>
          </List>
        </Box>
      </Drawer>
      <Box
        component="section"
        sx={{ flexGrow: 1, overflow: "auto", padding: 2 }}
        ref={sectionContainerRef}
      >
        {renderSectionContent()}
      </Box>
    </MainLayout>
  );
};

export default AdminPage;
